module.exports = __webpack_public_path__ + "img/Step05b3.2793b171.webp";